export default __webpack_public_path__ + "static/media/ETN.61ec8841.png";